import React from 'react';
import {
  AlertFullSpan,
  LinearLoadingIndicator,
} from '@storebrand-digital/pretzel';
import { CheckboxListProps } from './types';
import { Checkbox } from '@storebrand-digital/pretzel';
import styles from './DropdownFilter.module.css';
import { AlertInline } from '@storebrand-digital/pretzel';

const DropdownFilterCheckboxList: React.FC<CheckboxListProps> = ({
  name,
  options,
  selectedValues,
  onCheckboxChange,
  loading = false,
  error,
  listRef,
}) => {
  if (error) {
    return (
      <AlertInline heading="Internal Error" variant="error">
        {error}
      </AlertInline>
    );
  }

  if (loading) {
    return <LinearLoadingIndicator type="indeterminate" />;
  }

  return (
    <div className={styles.dropdownCheckboxList} data-hj-suppress="true">
      {options.map((option, index) => {
        const isSelected = selectedValues.includes(option.value);
        return (
          <Checkbox
            className={styles.dropdownCheckbox}
            key={`${name}-${option.value}`}
            ref={(node: HTMLInputElement) => {
              if (listRef) {
                listRef.current[index] = node;
              }
            }}
            role="option"
            id={`${name}-${option.value}`}
            name={name}
            label={option.label || '(blank)'}
            aria-selected={isSelected}
            aria-label={option.label}
            hint={
              option.info && (
                <AlertFullSpan variant="info" role="status">
                  <span className="font-body-small">{option.info}</span>
                </AlertFullSpan>
              )
            }
            value={String(option.value)}
            checked={isSelected}
            onChange={() => onCheckboxChange(option.value)}
          />
        );
      })}
    </div>
  );
};

export default DropdownFilterCheckboxList;
